"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Public surface of the API contracts package.
 *
 * Runtime consumers get the error contract types and constants from here; the
 * canonical OpenAPI artifact is published separately for tooling as
 * `@autocontrol/api-contracts/openapi/openapi.yaml`. Request/response DTO are
 * materialized alongside the endpoints that use them; no client is generated.
 */
__exportStar(require("./auth"), exports);
__exportStar(require("./problem"), exports);
__exportStar(require("./special-document-requirements"), exports);
//# sourceMappingURL=index.js.map